export default "__VITE_ASSET__83776d80__"